import clock from "./clock";
import { registerElement } from "./guidance";
import { createEl, join, makeArrowButton, makeButton } from "./svg-buttons";

const miscButtonsDefs = {
    color: "gray",
    borderColor: "black",
    borderWidth: 5,
    h: 67,
    w: 67,
};

export function makeKeyPad() {
    // KEYPAD
    const keypadDefs = { color: "gray", borderColor: "gray", fontSize: 24 };

    const keypad7 = makeButton({ x: 10, y: 0, t: "7", onClick: () => clock.onKeypad(7), ...keypadDefs });
    registerElement("KEYPAD_7", keypad7);
    const keypad8 = makeButton({ x: 11, y: 0, t: "8", onClick: () => clock.onKeypad(8), ...keypadDefs });
    registerElement("KEYPAD_8", keypad8);
    const keypad9 = makeButton({ x: 12, y: 0, t: "9", onClick: () => clock.onKeypad(9), ...keypadDefs });
    registerElement("KEYPAD_9", keypad9);

    const keypad4 = makeButton({ x: 10, y: 1, t: "4", onClick: () => clock.onKeypad(4), ...keypadDefs });
    registerElement("KEYPAD_4", keypad4);
    const keypad5 = makeButton({ x: 11, y: 1, t: "5", onClick: () => clock.onKeypad(5), ...keypadDefs });
    registerElement("KEYPAD_5", keypad5);
    const keypad6 = makeButton({ x: 12, y: 1, t: "6", onClick: () => clock.onKeypad(6), ...keypadDefs });
    registerElement("KEYPAD_6", keypad6);

    const keypad1 = makeButton({ x: 10, y: 2, t: "1", onClick: () => clock.onKeypad(1), ...keypadDefs });
    registerElement("KEYPAD_1", keypad1);
    const keypad2 = makeButton({ x: 11, y: 2, t: "2", onClick: () => clock.onKeypad(2), ...keypadDefs });
    registerElement("KEYPAD_2", keypad2);
    const keypad3 = makeButton({ x: 12, y: 2, t: "3", onClick: () => clock.onKeypad(3), ...keypadDefs });
    registerElement("KEYPAD_3", keypad3);

    makeButton({ ...keypadDefs, x: 10, y: 3, t: "CLEAR\n \nNO", fontSize: 15, onClick: () => clock.onClear() });
    const keypad0 = makeButton({ x: 11, y: 3, t: "0", onClick: () => clock.onKeypad(0), ...keypadDefs });
    registerElement("KEYPAD_0", keypad0);
    const keypadEnterYes = makeButton({ ...keypadDefs, x: 12, y: 3, t: "ENTER\n*\nYES", fontSize: 15, onClick: () => clock.onEnter() });
    registerElement("KEYPAD_ENTER", keypadEnterYes);

    makeButton({ x: 14, y: 1, t: "MENU", color: "black", fontColor: "white", onClick: () => clock.onMenu() });

    // Create the keypad background rect and register it as one element for guidance
    const keypadX = +keypad7.getAttribute("x")!;
    const keypadY = +keypad7.getAttribute("y")!;
    const keypadW = +keypadEnterYes.getAttribute("x")! + +keypadEnterYes.getAttribute("width")! - keypadX;
    const keypadH = +keypadEnterYes.getAttribute("y")! + +keypadEnterYes.getAttribute("height")! - keypadY;

    const keypadBg = createEl(
        "rect",
        {
            x: keypadX - 8,
            y: keypadY - 8,
            width: keypadW + 16,
            height: keypadH + 16,
            stroke: "gray",
            strokeWidth: 3,
            fill: "black",
            rx: 18,
            ry: 18,
        },
        { under: true }
    );
    registerElement("KEYPAD", keypadBg);
}

export function makeArrowButtons() {
    makeArrowButton(14, 0, 0, () => clock.onUpArrow());
    makeArrowButton(15, 1, 90);
    makeArrowButton(14, 2, 180, () => clock.onDownArrow());
    makeArrowButton(13, 1, 270);
}

export function makeRightButtons(noEdit?: boolean) {
    makeButton({
        ...miscButtonsDefs,
        x: 16,
        y: 0,
        t: "AUTO\nHORN\n&bull;",
        onClick: () => clock.onAutoHorn(),
    });

    const countUpDown = makeButton({
        ...miscButtonsDefs,
        x: 16,
        y: 2,
        t: "COUNT\nUP/DOWN\n&bull;",
    });

    const setMainClock = makeButton({
        ...miscButtonsDefs,
        x: 16,
        y: 3,
        t: "SET\nMAIN\nCLOCK\n&bull;",
        onClick: () => clock.onSetMainClock(),
    });
    registerElement("SET_MAIN_CLOCK", setMainClock);

    join(countUpDown, setMainClock, "black");

    const horn = makeButton({
        ...miscButtonsDefs,
        x: 17,
        y: 0,
        w: 88,
        t: "HORN",
        color: "gold",
        fontSize: 16,
    });
    horn.style.cursor = "pointer";
    horn.addEventListener("pointerdown", () => clock.onHornPress());
    horn.addEventListener("pointerup", () => clock.onHornRelease());
    horn.addEventListener("pointerleave", () => clock.onHornRelease());
    horn.addEventListener("pointercancel", () => clock.onHornRelease());

    createEl("circle", {
        cx: +horn.getAttribute("x")! + 10,
        cy: +horn.getAttribute("y")! + +horn.getAttribute("height")! - 10,
        r: 3,
        fill: "yellow",
        id: "autoHornLED",
        pointerEvents: "none",
    });

    const start = makeButton({
        ...miscButtonsDefs,
        x: 17,
        y: 1.7,
        w: 88,
        t: "START",
        color: "green",
        fontSize: 16,
        onClick: () => clock.onStart(),
    });
    registerElement("START", start);

    const startLED = createEl("circle", {
        cx: +start.getAttribute("x")! + 10,
        cy: +start.getAttribute("y")! + 10,
        r: 3,
        fill: "black",
        id: "startLED",
        pointerEvents: "none",
    });

    const stop = makeButton({
        ...miscButtonsDefs,
        x: 17,
        y: 3,
        w: 88,
        t: "STOP",
        color: "tomato",
        fontSize: 16,
        onClick: () => clock.stop(),
    });
    registerElement("STOP", stop);

    join(start, stop, "black");

    if (!noEdit) {
        const edit = makeButton({
            ...miscButtonsDefs,
            x: 14,
            y: 3,
            t: "EDIT",
        });
    }
}
